export var TYPES = ['T01', 'T02', 'T03', 'T04', 'T05', 'T06', 'T07', 'T08', 'T09', 'T10', 'T11', 'T12', 'T13', 'T14', 'T15', 'T16', 'T17', 'T18', 'T19', 'T20', 'T21'];
export var DEFAULT_TYPE = 'T02';
export var CHECKBOX_LABEL_DEFAULT_TYPE = 'T07';
export var THUMBNAIL_LABEL_DEFAULT_TYPE = 'T12';
export var PANEL_HEADER_CENTERED_TEXT_TITLE_DEFAULT_TYPE = 'T13';
export var PANEL_HEADER_CENTERED_TEXT_TITLE_TYPES = ['T13', 'T16', 'T09'];
export default {
  TYPES: TYPES,
  DEFAULT_TYPE: DEFAULT_TYPE,
  CHECKBOX_LABEL_DEFAULT_TYPE: CHECKBOX_LABEL_DEFAULT_TYPE,
  THUMBNAIL_LABEL_DEFAULT_TYPE: THUMBNAIL_LABEL_DEFAULT_TYPE,
  PANEL_HEADER_CENTERED_TEXT_TITLE_DEFAULT_TYPE: PANEL_HEADER_CENTERED_TEXT_TITLE_DEFAULT_TYPE,
  PANEL_HEADER_CENTERED_TEXT_TITLE_TYPES: PANEL_HEADER_CENTERED_TEXT_TITLE_TYPES
};